import { APP_NAME } from "./appLinks";

function wrap(ctx, text, maxW) {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; }
    else line = t;
  }
  if (line) lines.push(line);
  return lines;
}

// Render a verse onto the app's artwork as a shareable square-ish graphic.
// Returns a PNG Blob (same-origin background, so the canvas stays untainted).
export function makeVerseImage({ text, reference, translation }) {
  const W = 1080, H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  const draw = () => {
    // dark overlay so text is always legible
    const g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, "rgba(8,10,14,0.55)");
    g.addColorStop(0.5, "rgba(8,10,14,0.42)");
    g.addColorStop(1, "rgba(8,10,14,0.82)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);

    ctx.textAlign = "center";
    const fs = text.length > 220 ? 46 : text.length > 120 ? 56 : 66;
    ctx.font = `600 ${fs}px Georgia, 'Times New Roman', serif`;
    ctx.fillStyle = "#ffffff";
    ctx.shadowColor = "rgba(0,0,0,0.45)";
    ctx.shadowBlur = 12;
    const lines = wrap(ctx, `\u201C${text}\u201D`, W - 170);
    const lh = fs * 1.34;
    let y = H / 2 - (lines.length * lh) / 2;
    lines.forEach((ln) => { ctx.fillText(ln, W / 2, y); y += lh; });
    ctx.shadowBlur = 0;

    y += lh * 0.35;
    ctx.fillStyle = "#e9c46a";
    ctx.font = "700 40px Georgia, serif";
    ctx.fillText(`${reference}${translation ? `  \u00B7  ${translation}` : ""}`, W / 2, y);

    ctx.fillStyle = "rgba(255,255,255,0.9)";
    ctx.font = "700 32px -apple-system, 'Segoe UI', Roboto, sans-serif";
    ctx.fillText(APP_NAME, W / 2, H - 96);
    ctx.fillStyle = "rgba(255,255,255,0.62)";
    ctx.font = "500 25px -apple-system, 'Segoe UI', Roboto, sans-serif";
    ctx.fillText("Read it free on Google Play", W / 2, H - 56);
  };

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const r = Math.max(W / img.width, H / img.height);
      const w = img.width * r, h = img.height * r;
      ctx.drawImage(img, (W - w) / 2, (H - h) / 2, w, h);
      draw();
      canvas.toBlob((b) => resolve(b), "image/png", 0.92);
    };
    img.onerror = () => {
      ctx.fillStyle = "#11151a"; ctx.fillRect(0, 0, W, H);
      draw();
      canvas.toBlob((b) => resolve(b), "image/png", 0.92);
    };
    img.src = "/cards/votd.jpg";
  });
}
